@if (formGroup) {
  <div [formGroup]="formGroup">
    <ng-select
      class="w-full"
      [items]="senderRecieverTypes"
      formControlName="{{ prefix }}type"
      placeholder="Absender"
      [clearable]="false"
      bindLabel="name"
      bindValue="id"
      (change)="onAddressTypeChange($event)"
    >
      <ng-template ng-label-tmp let-item="item">
        {{ item.name }}
      </ng-template>
      <ng-template ng-option-tmp let-item="item" let-search="searchTermStatus">
        @if (!search || item.name.toLowerCase().includes(search.toLowerCase())) {
          {{ item.name }}
        }
      </ng-template>
    </ng-select>
  </div>
  <span> </span>
  @if (formGroup.controls[prefix + "type"].value === "TECHNICIAN" && technicians) {
    <div [formGroup]="formGroup">
      <ng-select
        class="w-full"
        [items]="technicians"
        bindLabel="name"
        bindValue="id"
        formControlName="{{ prefix }}technician"
        placeholder="Techniker"
        [clearable]="false"
        (change)="onAddressChange($event)"
      >
        <ng-template ng-label-tmp let-item="item">
          {{ item.name }}
        </ng-template>
        <ng-template ng-option-tmp let-item="item" let-search="searchTermStatus">
          @if (!search || item.name.toLowerCase().includes(searchTerm.toLowerCase())) {
            {{ item.name }}
          }
        </ng-template>
      </ng-select>
    </div>
  }
  @if (formGroup.controls[prefix + "type"].value === "WAREHOUSE" && wareHouses) {
    <div [formGroup]="formGroup">
      <ng-select
        class="w-full"
        [items]="wareHouses"
        bindLabel="label"
        bindValue="id"
        formControlName="{{ prefix }}warehouse"
        placeholder="Lager"
        [clearable]="false"
        (change)="onAddressChange($event)"
      >
        <ng-template ng-label-tmp let-item="item">
          {{ item.label }}
        </ng-template>
        <ng-template ng-option-tmp let-item="item" let-search="searchTermStatus">
          @if (item.label.toLowerCase().includes(searchTerm.toLowerCase())) {
            <div>
              {{ item.label }}
            </div>
          }
        </ng-template>
      </ng-select>
    </div>
  }
  @if (formGroup.controls[prefix + "type"].value === "CUSTOMER" && customers) {
    <div [formGroup]="formGroup" class="flex flex-row gap-2">
      <ng-select
        class="w-full flex-1"
        [items]="customers"
        bindLabel="name"
        bindValue="id"
        formControlName="{{ prefix }}customer"
        placeholder="Kunde"
        [clearable]="false"
        (change)="onChangeCustomer($event)"
        [loading]="loadingCustomers"
        [virtualScroll]="true"
        (scrollToEnd)="fetchMoreCustomers()"
      >
        <ng-template ng-label-tmp let-item="item">
          {{ item.name }}
        </ng-template>
        <ng-template ng-option-tmp let-item="item" let-search="searchTermStatus">
          @if (!search || item.name.toLowerCase().includes(search.toLowerCase())) {
            {{ item.name }}
          }
        </ng-template>
      </ng-select>
      <ng-select
        class="w-full flex-1"
        [items]="filteredStores"
        bindLabel="name"
        bindValue="id"
        formControlName="{{ prefix }}store"
        placeholder="Store"
        [clearable]="false"
        (change)="onAddressChange($event)"
        [loading]="loading"
        [virtualScroll]="true"
        (scrollToEnd)="fetchMoreStores()"
      >
        <ng-template ng-label-tmp let-item="item"> {{ item.name }} - {{ item.nr }} </ng-template>
        <ng-template ng-option-tmp let-item="item" let-search="searchTermStatus">
          @if (!search || item.name.toLowerCase().includes(searchTerm.toLowerCase())) {
            {{ item.name }} - {{ item.nr }}
          }
        </ng-template>
      </ng-select>
    </div>
  }
}
